import { call, put } from "redux-saga/effects";
import * as types from "../consts";
import { getTenantUserList, deleteUserRowRequest, updateUserRowRequest } from "../api";

export function* getTenantUserListSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const tenantsList: object = yield call(getTenantUserList, payload);
    yield put({
      type: types.GET_TENANT_USER_LIST_SUCCESS,
      response: tenantsList,
    });
  } catch (error) {
    yield put({ type: types.GET_TENANT_USER_LIST_ERROR, error });
  }
}

export function* deleteUserRowRequestSaga({
  payload,
}: ReturnType<typeof Object>) {
  try {
    const tenantsList: object = yield call(deleteUserRowRequest, payload);
    yield put({ type: types.DELETE_USER_ROW_SUCCESS, response: tenantsList });
  } catch (error) {
    yield put({ type: types.DELETE_USER_ROW_ERROR, error });
  }
}

export function* updateUserRowRequestSaga({
  payload,
}: ReturnType<typeof Object>) {
  try {
    const tenantsList: object = yield call(updateUserRowRequest, payload);
    yield put({ type: types.UPDATE_USER_ROW_SUCCESS, response: tenantsList });
  } catch (error) {
    yield put({ type: types.UPDATE_USER_ROW_ERROR, error });
  }
}
